module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("je05t"))).then(() => module.bundle.root('1iHdE'));